// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountUpdateAccountDefaultResponse {
    static getAttributeTypeMap() {
        return AccountUpdateAccountDefaultResponse.attributeTypeMap;
    }
}
AccountUpdateAccountDefaultResponse.discriminator = undefined;
AccountUpdateAccountDefaultResponse.additionalProperties = false;
AccountUpdateAccountDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "IUpdateAccountModel"
    },
];
//# sourceMappingURL=accountUpdateAccountDefaultResponse.js.map